// ======================================================================
// File Name       : page
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionType from '../constants/actionTypes/page';

const initialState = {
  reloadComponent: null,
  parentPath: '',
  searchCondition: {},
  showLoading: false,
  parentPathSub: '',
  searchConditionSub: {},
  parentPathHistory: '',
  searchConditionHistoy: {},
};

export default function page(state = initialState, action) {
  switch (action.type) {
    case actionType.RELOAD_COMPONENT: {
      return {
        ...state,
        reloadComponent: !state.reloadComponent,
        parentPath: '',
        searchCondition: {},
        parentPathSub: '',
        searchConditionSub: {},
        parentPathHistory: '',
        searchConditionHistoy: {},
      };
    }
    case actionType.SAVE_SEARCH_CONDITION: {
      const { parentPath, searchCondition } = action;
      return {
        ...state,
        parentPath,
        searchCondition,
      };
    }

    case actionType.CLEAR_SEARCH_CONDITION: {
      const { parentPath, searchCondition } = initialState;
      return {
        ...state,
        parentPath,
        searchCondition,
      };
    }

    case actionType.SAVE_SEARCH_CONDITION_SUB: {
      const { parentPathSub, searchConditionSub } = action;
      return {
        ...state,
        parentPathSub,
        searchConditionSub,
      };
    }

    case actionType.CLEAR_SEARCH_CONDITION_SUB: {
      const { parentPathSub, searchConditionSub, parentPathHistory, searchConditionHistoy } = initialState;
      return {
        ...state,
        parentPathSub,
        searchConditionSub,
        parentPathHistory,
        searchConditionHistoy,
      };
    }

    case actionType.SAVE_SEARCH_CONDITION_HISTORY: {
      const { parentPathHistory, searchConditionHistoy } = action;
      return {
        ...state,
        parentPathHistory,
        searchConditionHistoy,
      };
    }

    case actionType.SHOW_LOADING: {
      return {
        ...state,
        showLoading: true,
      };
    }

    case actionType.HIDE_LOADING: {
      return {
        ...state,
        showLoading: false,
      };
    }

    default:
      return state;
  }
}
